export function stripMarkTags(html: string): string {
  if (!html) {
    return html;
  }

  return html.replace(/<\/?mark>/g, '');
}
